/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerListTransfersQueryResponse, TransfersControllerListTransfersQueryParams, TransfersControllerListTransfers401, TransfersControllerListTransfers403 } from "../../models/transfersController/TransfersControllerListTransfers";

function getTransfersControllerListTransfersUrl() {
  const res = { method: 'GET', url: `/api/v1/transfers` as const }  
  return res
}

/**
 * @summary List all transfer runs
 * {@link /api/v1/transfers}
 */
export async function transfersControllerListTransfers(params?: TransfersControllerListTransfersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransfersControllerListTransfersQueryResponse, ResponseErrorConfig<TransfersControllerListTransfers401 | TransfersControllerListTransfers403>, unknown>({ method : "GET", url : getTransfersControllerListTransfersUrl().url.toString(), params, ... requestConfig })  
  return res.data
}